import { Button, Pill, Text } from "components/commons";
import styles from "../shift-records-details-cash-and-non-cash.module.scss";
import { formatAmount } from "utils";
import { prettifyPaymentMethod } from "utils/pretty.utils";
import { PaymentMethod } from "enums";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import locale from "localization";
// import { getCashAndNonCashTotals } from "../shift-records-details-cash-non-cash.mapper";
export const nonCashSummaryMapper = ({
  val,
  onViewPaymentMethodTransaction,
  nonCashTransactions = [],
  transactionsItemDetails = [],
  isView = false,
}) => {
  let {
    transactionCount,
    adjustmentCount,
    actionNeeded,
    method,
    methods,
    excessAmount,
    // transactions: paymentMethodsTransactions,
    discount,
    // amountPaid,
    totalAmount,
    finalAmount,
    vatAmount,
    // transactions,
  } = val;
  const paymentMethod =
    prettifyPaymentMethod(method) +
    ([PaymentMethod.GiftCard, PaymentMethod.Other].includes(method) ? "s" : "");

  // const totalAmount = transactions.reduce((acc, transaction) => {
  //   return acc + transaction.totalAmount;
  // }, 0);

  // const hasPremium = Math.abs(premium ?? 0) > 0.005;
  // const hasPremium = discount > 0.0005;
  // const hasDiscount = !hasPremium && Math.abs(discount ?? 0) > 0.005;

  return {
    method: (
      <div className={styles.methodCell}>
        <Text className={styles.content}>{paymentMethod}</Text>
        {actionNeeded && (
          <Pill deepRed className={styles.actionNeededPill}>
            {locale.actionNeeded}
          </Pill>
        )}
      </div>
    ),
    transactionCount: (
      <div className={styles.transactionCountCell}>
        <Text className={styles.content}>{transactionCount}</Text>
        {adjustmentCount > 0 && (
          <Pill className={styles.adjustmentCountPill}>
            {locale.populate(locale.xAdjustments, [adjustmentCount])}
          </Pill>
        )}
      </div>
    ),
    totalAmount: <Text className={styles.content}>{formatAmount(totalAmount)}</Text>,
    // discount: (
    //   <Text className={hasDiscount ? styles.negative : styles.content}>
    //     {hasPremium
    //       ? formatAmount(Math.abs(premium ?? 0))
    //       : `${hasDiscount ? "-" : ""}${formatAmount(Math.abs(discount ?? 0))}`}
    //   </Text>
    // ),
    discount: (
      <Text className={discount < 0 ? styles.negative : styles.content}>
        {`${discount < 0 ? "-" : ""}${formatAmount(discount)}`}
      </Text>
    ),
    finalAmount: (
      <>
        <Text className={styles.content}>{formatAmount(finalAmount)}</Text>
        {!isNaN(excessAmount) && excessAmount >= 0.005 && (
          <Text className={styles.italic}>
            {"Excess:"}
            {formatAmount(excessAmount)}
          </Text>
        )}
      </>
    ),
    // excess: (
    //   <Text className={styles.content}>

    //   </Text>
    // ),
    vatExempt: (() => {
      const vatVal = vatAmount ?? 0;
      return (
        <Text className={vatVal < 0 ? styles.negative : styles.content}>
          {vatVal < 0 ? `-${formatAmount(-vatVal)}` : formatAmount(vatVal)}
        </Text>
      );
    })(),
    actions: (
      <Button
        style={{ textDecoration: "none" }}
        link
        onClick={() => onViewPaymentMethodTransaction(method, methods)}
      >
        <div
          style={{
            color: "#5349b7",
            fontWeight: "500",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <span>{actionNeeded && !isView ? locale.tagAccountability : locale.view}</span>
          <NavigateNextIcon fontSize="small" />
        </div>
      </Button>
    ),
  };
};
